"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageMediaData = void 0;
const react_1 = __importStar(require("react"));
const spa_core_1 = require("@episerver/spa-core");
const ImageMediaData = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35;
    const [isFinnish, setIsFinnish] = (0, react_1.useState)(false);
    const breakPoints = {
        xxl: {
            cssMedia: '(min-width: 1400px)',
            imgWidth: '1920',
            maxImageWidth: ((_a = props.data.use2XImages) === null || _a === void 0 ? void 0 : _a.value) ? 3192 : 1920,
            minImageWidth: ((_b = props.data.use2XImages) === null || _b === void 0 ? void 0 : _b.value) ? 2320 : 1400
        },
        xl: {
            cssMedia: '(min-width: 1200px)',
            imgWidth: '1400',
            maxImageWidth: ((_c = props.data.use2XImages) === null || _c === void 0 ? void 0 : _c.value) ? 2320 : 1400,
            minImageWidth: ((_d = props.data.use2XImages) === null || _d === void 0 ? void 0 : _d.value) ? 1990 : 1200
        },
        lg: {
            cssMedia: '(min-width: 992px)',
            imgWidth: '1200',
            maxImageWidth: ((_e = props.data.use2XImages) === null || _e === void 0 ? void 0 : _e.value) ? 1990 : 1200,
            minImageWidth: ((_f = props.data.use2XImages) === null || _f === void 0 ? void 0 : _f.value) ? 1625 : 992
        },
        md: {
            cssMedia: '(min-width: 860px)',
            imgWidth: '992',
            maxImageWidth: ((_g = props.data.use2XImages) === null || _g === void 0 ? void 0 : _g.value) ? 1625 : 992,
            minImageWidth: ((_h = props.data.use2XImages) === null || _h === void 0 ? void 0 : _h.value) ? 1363 : 860
        },
        sm: {
            cssMedia: '(min-width: 576px)',
            imgWidth: '860',
            maxImageWidth: ((_j = props.data.use2XImages) === null || _j === void 0 ? void 0 : _j.value) ? 1718 : 860,
            minImageWidth: ((_k = props.data.use2XImages) === null || _k === void 0 ? void 0 : _k.value) ? 1152 : 576
        },
        img: {
            cssMedia: '(min-width: 1px)',
            imgWidth: '576',
            maxImageWidth: ((_l = props.data.use2XImages) === null || _l === void 0 ? void 0 : _l.value) ? 1152 : 576,
            minImageWidth: 0
        }
    };
    const ctx = (0, spa_core_1.useEpiserver)();
    const parentVariables = props.parentVar && typeof (props.parentVar) === 'object' ? props.parentVar : {};
    //choosing correct max width. Take it from parent var if exists. If not, take it from image. Parent var value should never be bigger that image value
    const imageMaxWidth = parentVariables.width ?
        (((_m = props.data.width) === null || _m === void 0 ? void 0 : _m.value) && parentVariables.width > ((_o = props.data.width) === null || _o === void 0 ? void 0 : _o.value) ? props.data.width.value : parentVariables.width) :
        (((_p = props.data.width) === null || _p === void 0 ? void 0 : _p.value) && props.data.width.value > 0 ? props.data.width.value : 0);
    const renderOnlyImage = parentVariables.renderOnlyImage;
    const lazy = parentVariables.lazy;
    let imageheight = 0;
    let cssClass = `${((_q = props.data.restrictedSize) === null || _q === void 0 ? void 0 : _q.value) ? '' : 'img-fluid w-100'}`;
    const styles = {
        maxWidth: '100%',
        width: ((_r = props.data.cropImage) === null || _r === void 0 ? void 0 : _r.value) || ((_s = props.data.cropMobImage) === null || _s === void 0 ? void 0 : _s.value) || ((_t = props.data.restrictedSize) === null || _t === void 0 ? void 0 : _t.value) ? 'auto' : '100%'
    };
    let altText = isFinnish ? (_v = (_u = props.data) === null || _u === void 0 ? void 0 : _u.altTextFI) === null || _v === void 0 ? void 0 : _v.value : (_x = (_w = props.data) === null || _w === void 0 ? void 0 : _w.altTextEN) === null || _x === void 0 ? void 0 : _x.value;
    if (props.className !== undefined)
        cssClass = cssClass + ' ' + props.className;
    if (!props.data.url)
        return react_1.default.createElement("span", { className: cssClass.trim() + ' no-img' });
    let imgUrl = new URL(spa_core_1.Core.DefaultContext.getEpiserverUrl(props.data.url));
    imgUrl.searchParams.set('quality', '80'); //Lossy processing
    let webpUrl = new URL(spa_core_1.Core.DefaultContext.getEpiserverUrl(props.data.url));
    webpUrl.searchParams.set('format', 'webp'); //Format as WebP
    webpUrl.searchParams.set('quality', '80'); //Lossy processing
    const showAriaDescribedBy = (((_y = props.data.ariaDescribedByTextFI) === null || _y === void 0 ? void 0 : _y.value) !== '')
        || (((_z = props.data.ariaDescribedByText) === null || _z === void 0 ? void 0 : _z.value) !== '');
    const ariaAttributes = showAriaDescribedBy ? { 'aria-describedby': `${props.data.contentLink.id}` } : {};
    let sources = new Array();
    let keyPrefix = `img-${props.data.contentLink.id}-`;
    for (let size in breakPoints) {
        if (imageMaxWidth !== 0 && imageMaxWidth < breakPoints[size].maxImageWidth) {
            imgUrl.searchParams.set('width', `${imageMaxWidth}`);
            webpUrl.searchParams.set('width', `${imageMaxWidth}`);
        }
        else {
            imgUrl.searchParams.set('width', `${breakPoints[size].maxImageWidth}`);
            webpUrl.searchParams.set('width', `${breakPoints[size].maxImageWidth}`);
        }
        if (size !== 'img' && ((_0 = props.data.cropImage) === null || _0 === void 0 ? void 0 : _0.value)) {
            //rxy=0.37,0.78
            let rxy;
            if ((_1 = props.data.cropPosX) === null || _1 === void 0 ? void 0 : _1.value)
                rxy = `${props.data.cropPosX.value / 100}`;
            if ((_2 = props.data.cropPosY) === null || _2 === void 0 ? void 0 : _2.value) {
                rxy = `${rxy !== undefined ? rxy : '0.0,'}${rxy !== undefined ? ',' : ''}${props.data.cropPosY.value / 100}`;
            }
            else if (rxy) {
                rxy = `${rxy},0.0`;
            }
            if ((_3 = props.data.cropWidth) === null || _3 === void 0 ? void 0 : _3.value) {
                webpUrl.searchParams.set('width', `${(_4 = props.data.cropWidth) === null || _4 === void 0 ? void 0 : _4.value}`);
                imgUrl.searchParams.set('width', `${(_5 = props.data.cropWidth) === null || _5 === void 0 ? void 0 : _5.value}`);
            }
            if ((_6 = props.data.cropHeight) === null || _6 === void 0 ? void 0 : _6.value) {
                webpUrl.searchParams.set('height', `${(_7 = props.data.cropHeight) === null || _7 === void 0 ? void 0 : _7.value}`);
                imgUrl.searchParams.set('height', `${(_8 = props.data.cropHeight) === null || _8 === void 0 ? void 0 : _8.value}`);
            }
            webpUrl.searchParams.set('rmode', 'crop');
            if (rxy)
                webpUrl.searchParams.set('rxy', rxy);
            imgUrl.searchParams.set('rmode', 'crop');
            if (rxy)
                imgUrl.searchParams.set('rxy', rxy);
        }
        if (size === 'img' && ((_9 = props.data.cropMobImage) === null || _9 === void 0 ? void 0 : _9.value)) {
            //rxy=0.37,0.78
            let mobrxy;
            if ((_10 = props.data.mobCropPosX) === null || _10 === void 0 ? void 0 : _10.value)
                mobrxy = `${props.data.mobCropPosX.value / 100}`;
            if ((_11 = props.data.mobCropPosY) === null || _11 === void 0 ? void 0 : _11.value) {
                mobrxy = `${mobrxy !== undefined ? mobrxy : '0.0,'}${mobrxy !== undefined ? ',' : ''}${props.data.mobCropPosY.value / 100}`;
            }
            else if (mobrxy) {
                mobrxy = `${mobrxy},0.0`;
            }
            webpUrl.searchParams.set('width', `${(_12 = props.data.mobWidth) === null || _12 === void 0 ? void 0 : _12.value}`);
            webpUrl.searchParams.set('height', `${(_13 = props.data.mobHeight) === null || _13 === void 0 ? void 0 : _13.value}`);
            webpUrl.searchParams.set('rmode', 'crop');
            if (mobrxy)
                webpUrl.searchParams.set('rxy', mobrxy);
            imgUrl.searchParams.set('rmode', 'crop');
            imgUrl.searchParams.set('width', `${(_14 = props.data.mobWidth) === null || _14 === void 0 ? void 0 : _14.value}`);
            imgUrl.searchParams.set('height', `${(_15 = props.data.mobHeight) === null || _15 === void 0 ? void 0 : _15.value}`);
            if (mobrxy)
                imgUrl.searchParams.set('rxy', mobrxy);
        }
        try {
            if (((_16 = props.data.width) === null || _16 === void 0 ? void 0 : _16.value) > 0 && ((_17 = props.data.height) === null || _17 === void 0 ? void 0 : _17.value) > 0) {
                const aspectRatio = ((_19 = (_18 = props.data) === null || _18 === void 0 ? void 0 : _18.width) === null || _19 === void 0 ? void 0 : _19.value) / ((_21 = (_20 = props.data) === null || _20 === void 0 ? void 0 : _20.height) === null || _21 === void 0 ? void 0 : _21.value);
                imageheight = Math.round(imageMaxWidth / aspectRatio);
            }
            else
                imageheight = 0;
        }
        catch (_36) {
            imageheight = 0;
        }
        if (size === 'img') {
            sources.push(react_1.default.createElement("source", { media: breakPoints[size].cssMedia, srcSet: webpUrl.href, type: "image/webp", key: keyPrefix + size + '-webp', width: imageheight > 0 ? imageMaxWidth : '', height: imageheight > 0 ? imageheight : '' }));
            sources.push(react_1.default.createElement("img", Object.assign({}, ariaAttributes, { loading: `${lazy ? 'lazy' : 'eager'}`, width: ((_22 = props.data.width) === null || _22 === void 0 ? void 0 : _22.value) && `${props.data.width.value}`, height: ((_23 = props.data.height) === null || _23 === void 0 ? void 0 : _23.value) && `${props.data.height.value}`, src: imgUrl.href, style: styles, className: cssClass.trim(), key: keyPrefix + size, alt: altText })));
        }
        else if (imageMaxWidth === 0 || breakPoints[size].minImageWidth < imageMaxWidth) {
            sources.push(react_1.default.createElement("source", { media: breakPoints[size].cssMedia, srcSet: webpUrl.href, type: "image/webp", key: keyPrefix + size + '-webp', width: imageheight > 0 ? imageMaxWidth : '', height: imageheight > 0 ? imageheight : '' }));
            sources.push(react_1.default.createElement("source", { media: breakPoints[size].cssMedia, srcSet: imgUrl.href, key: keyPrefix + size, width: imageheight > 0 ? imageMaxWidth : '', height: imageheight > 0 ? imageheight : '' }));
        }
    }
    const showDescription = !renderOnlyImage && ((((_24 = props.data.descriptionText) === null || _24 === void 0 ? void 0 : _24.value) !== '')
        || (((_25 = props.data.descriptionTextFI) === null || _25 === void 0 ? void 0 : _25.value) !== ''));
    const showCredits = !renderOnlyImage && ((((_26 = props.data.creditsTextFI) === null || _26 === void 0 ? void 0 : _26.value) !== '')
        || (((_27 = props.data.creditsText) === null || _27 === void 0 ? void 0 : _27.value) !== ''));
    (0, react_1.useEffect)(() => {
        setIsFinnish(ctx.Language === 'fi');
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("picture", null, sources),
        (showDescription || showCredits) &&
            react_1.default.createElement("div", { className: 'pt-3 mb-5 additional-info' },
                showDescription &&
                    react_1.default.createElement("p", { className: 'image-description mb-0' }, isFinnish ? (_28 = props.data.descriptionTextFI) === null || _28 === void 0 ? void 0 : _28.value : (_29 = props.data.descriptionText) === null || _29 === void 0 ? void 0 : _29.value),
                showCredits &&
                    react_1.default.createElement("p", { className: `image-credits x-small ${(((_30 = props.data.descriptionText) === null || _30 === void 0 ? void 0 : _30.value) || ((_31 = props.data.descriptionTextFI) === null || _31 === void 0 ? void 0 : _31.value)) ? 'pt-1' : ''}` }, isFinnish ? (_32 = props.data.creditsTextFI) === null || _32 === void 0 ? void 0 : _32.value : (_33 = props.data.creditsText) === null || _33 === void 0 ? void 0 : _33.value)),
        showAriaDescribedBy &&
            react_1.default.createElement("p", { className: 'visually-hidden', id: `${props.data.contentLink.id}` }, isFinnish ? (_34 = props.data.ariaDescribedByTextFI) === null || _34 === void 0 ? void 0 : _34.value : (_35 = props.data.ariaDescribedByText) === null || _35 === void 0 ? void 0 : _35.value));
};
exports.ImageMediaData = ImageMediaData;
exports.default = exports.ImageMediaData;
